import { ISmpBundle } from '../models';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/SmpBundles';

export const SmpBundlesAPI = {
  async getAll(): Promise<ISmpBundle[]> {
    try {
      const response: AxiosResponse<ISmpBundle[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: ISmpBundle[]): Promise<ISmpBundle[]> {
    try {
      const response: AxiosResponse<ISmpBundle[]> = await authFetch.post(`${baseUrl}/upsert`, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(smpBundleId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${smpBundleId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data?.Detail);
      }
      throw error;
    }
  },
};
